import axios from 'axios';

import routes from 'app/routes';

const prepareFormDataForSend = (values) => ({
  topic: values.topic,
  agenda: values.agenda,
  start_date: values.start_date,
  start_time: values.start_time,
  time_zone: values.time_zone,
  host_type: values.hostType,
  host_id: values.hostId,
  duration: values.duration,
});

export default {
  load: (dispatch) => {
    axios
      .get(routes.api.webinars.index)
      .then((resp) => {
        dispatch({ type: 'LOAD', webinars: resp.data.data });
      });
  },

  create: (dispatch, values, onSuccess, onError) => {
    axios
      .post(routes.api.webinars.create, {
        webinar: { ...prepareFormDataForSend(values) },
      })
      .then((resp) => {
        dispatch({ type: 'CREATE', webinar: resp.data.data });
        onSuccess();
      })
      .catch((error, _data) => {
        onError(error.response.data.errors);
      });
  },

  start: (webinarId, onSuccess) => {
    axios
      .get(routes.api.webinars.start(webinarId))
      .then((resp) => {
        onSuccess(resp.data.data);
      });
  },

  update: (dispatch, webinarId, values, onSuccess, onError) => {
    axios
      .patch(routes.api.webinars.update(webinarId), {
        webinar: { ...prepareFormDataForSend(values) },
      })
      .then((resp) => {
        dispatch({ type: 'UPDATE', webinar: resp.data.data });
        onSuccess();
      })
      .catch((error, _data) => {
        onError(error.response.data.errors);
      });
  },

  delete: (dispatch, webinarId) => {
    axios
      .delete(routes.api.webinars.destroy(webinarId))
      .then((_resp) => {
        dispatch({ type: 'DELETE', webinarId });
      });
  },
};
